import { Flex, Icon } from "@appsmith/ads";
import React, { useCallback } from "react";
import { ToolCheckBox } from "./ToolCheckBox";
import { ToolEditControls } from "./ToolEditControls";
import type { Tool } from "../types";
import { useBoolean } from "usehooks-ts";

interface ToolCheckListItemProps {
  tool: Tool;
  icon: React.ReactNode;
  onToolSelect: (tool: Tool) => void;
  onToolEdit: (tool: Tool, triggerSave?: boolean) => void;
}
export const ToolCheckListItem = (props: ToolCheckListItemProps) => {
  const { icon, onToolEdit, onToolSelect, tool } = props;
  const {
    setFalse: closeEditing,
    setValue: setIsEditing,
    value: isEditing,
  } = useBoolean(false);

  const handleDescriptionSave = useCallback(
    (value: string) => {
      onToolEdit(
        {
          ...tool,
          description: value,
        },
        true,
      );
      closeEditing();
    },
    [onToolEdit, closeEditing, tool],
  );

  const handleApprovalChange = useCallback(
    (isApprovalRequired: boolean) => {
      onToolEdit({ ...tool, isApprovalRequired });
    },
    [onToolEdit, tool],
  );

  return (
    <ToolCheckBox
      isEditing={isEditing}
      isSelected={tool.isSelected}
      key={tool.entityId}
      label={tool.name}
      onClick={() => onToolSelect(tool)}
    >
      <Flex
        alignItems="center"
        flex="1"
        gap="spaces-2"
        justifyContent="space-between"
      >
        <Flex height="16px" ml="spaces-2" width="16px">
          {tool.isApprovalRequired && (
            <Icon name="shield-user-line" size="md" />
          )}
        </Flex>
        <ToolEditControls
          handleApprovalChange={handleApprovalChange}
          handleDescriptionSave={handleDescriptionSave}
          icon={icon}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          tool={tool}
        />
      </Flex>
    </ToolCheckBox>
  );
};
